import { lazyRouteComponent } from "@tanstack/react-router";
import { FlaskConical } from "lucide-react";

import type { PageDef } from "@/app/registry";

export interface BacktestListSearch {
  /** Show runs labelled STALE (invalidated by a later fix). */
  stale?: boolean;
  /** Show walk-forward train windows (child runs). */
  windows?: boolean;
  kind: "all" | "equity" | "fno";
}

export function parseListSearch(s: Record<string, unknown>): BacktestListSearch {
  const on = (v: unknown) => v === true || v === "true" || v === "1" || v === 1;
  return {
    ...(on(s.stale) ? { stale: true } : {}),
    ...(on(s.windows) ? { windows: true } : {}),
    kind: s.kind === "equity" || s.kind === "fno" ? s.kind : "all",
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/backtests",
    proOnly: true,
    title: "Backtests",
    component: lazyRouteComponent(() => import("./BacktestList"), "BacktestList"),
    nav: { label: "Backtests", icon: FlaskConical, group: "Premium", order: 40 },
    validateSearch: parseListSearch,
  },
  {
    path: "/app/backtests/$runId",
    proOnly: true,
    title: "Backtest",
    component: lazyRouteComponent(() => import("./BacktestDetail"), "BacktestDetail"),
  },
];
